export const calculateNps = (promoters, passives, detractors) => {
  const p = Number(promoters) || 0;
  const pa = Number(passives) || 0;
  const d = Number(detractors) || 0;
  const total = p + pa + d;

  if (total === 0) return 0;

  return Math.round(((p / total) * 100 - (d / total) * 100) * 10) / 10;
};

export const getNpsBreakdown = (promoters, passives, detractors) => {
  const p = Number(promoters) || 0;
  const pa = Number(passives) || 0;
  const d = Number(detractors) || 0;
  const total = p + pa + d;

  const toPercent = (count) =>
    total > 0 ? Math.round((count / total) * 1000) / 10 : 0;

  return {
    promoters: p,
    passives: pa,
    detractors: d,
    total,
    promoterPercent: toPercent(p),
    passivePercent: toPercent(pa),
    detractorPercent: toPercent(d),
    nps: calculateNps(p, pa, d),
  };
};
